import { useMemo } from 'react'

import window from 'browser-lib/window'

export const useTrackEventsSessionId = () => {
  return useMemo(() => window?.localStorage?.getItem('sessionId'), [])
}
